import type { JSX } from 'react'

import { IconProps, iconColor } from './IconProps'

export function MoneyIcon(props: IconProps): JSX.Element {
  const size = props.size || 24

  return (
    <svg
      {...props}
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 25 24'
      fill='none'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12.1377 2.9166C12.6951 2.9166 13.147 3.36846 13.147 3.92586V4.35209C15.341 4.74494 17.184 6.39333 17.184 8.63577C17.184 9.19318 16.7322 9.64504 16.1748 9.64504C15.6174 9.64504 15.1655 9.19318 15.1655 8.63577C15.1655 7.72278 14.4064 6.75638 13.147 6.41199V11.0805C15.341 11.4734 17.184 13.1218 17.184 15.3642C17.184 17.6067 15.341 19.2551 13.147 19.6479V20.0741C13.147 20.6315 12.6951 21.0834 12.1377 21.0834C11.5803 21.0834 11.1284 20.6315 11.1284 20.0741V19.6479C8.93437 19.2551 7.09135 17.6067 7.09135 15.3642C7.09135 14.8068 7.54322 14.355 8.10062 14.355C8.65802 14.355 9.10989 14.8068 9.10989 15.3642C9.10989 16.2772 9.86899 17.2436 11.1284 17.588V12.9195C8.93437 12.5266 7.09135 10.8782 7.09135 8.63577C7.09135 6.39333 8.93437 4.74494 11.1284 4.35209V3.92586C11.1284 3.36846 11.5803 2.9166 12.1377 2.9166ZM11.1284 6.41199C9.86899 6.75638 9.10989 7.72278 9.10989 8.63577C9.10989 9.54877 9.86899 10.5152 11.1284 10.8596V6.41199ZM15.1655 15.3642C15.1655 14.4512 14.4064 13.4848 13.147 13.1404V17.588C14.4064 17.2436 15.1655 16.2772 15.1655 15.3642Z'
        fill={iconColor(props)}
      />
    </svg>
  )
}
